class TableActionsCreator {
  constructor() {
    this.tableButtons = { selectionButtons: [], defaultButtons: [] }
  }

  addUbliqueBtn(props) {
    // const { id, type, label, action, icon, selectionBtn = false } = props

    const { selectionBtn = false, ...btnProps } = props

    const button = new UbliqueBtn({ ...btnProps })

    if (selectionBtn) {
      this.tableButtons.selectionButtons.push(button.getUbliqueBtn())
    } else {
      this.tableButtons.defaultButtons.push(button.getUbliqueBtn())
    }
  }

  getTableButtons() {
    return this.tableButtons
  }
}

class UbliqueBtn {
  constructor({
    id,
    type = 'primary',
    label,
    action,
    icon = 'none',
    disabled = false,
    componentProps
  }) {
    this.id = id
    this.type = type
    this.text = label
    this.action = action
    this.icon = icon
    this.disabled = disabled
    this.componentProps = componentProps
  }

  getUbliqueBtn() {
    return {
      id: this.id,
      type: this.type,
      icon: this.icon,
      text: this.text,
      action: this.action,
      disabled: this.disabled,
      componentProps: this.componentProps
    }
  }
}

export default TableActionsCreator
